import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/all';
import { IUserPreference, IUserHomeAnnouncement } from '../../models/action/userPreference';
import { Log, Level, Logger } from 'ng2-logger';

const _logger = Log.create('Homepage Box');

const userPreferenceReducer = (state = GlobalState().userPreference, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    let newState: any = {};
    newState= { ...state};
    if (action.type === Actions.userPreferenceActions.GET_USERPREFERENCE) {
        const userPreference = (action as IUserPreference);
        newState.userPreferenceList = userPreference.userPreferenceData;
    } else if (action.type === Actions.userPreferenceActions.GET_HOME_ANNOUNCEMENT) {
        const userPreference = (action as IUserHomeAnnouncement);
        newState.userHomeAnnouncementList = userPreference.userHomeAnnouncementData;
    } else {
        return state;
    }
    return Object.assign({}, state, newState);
};

export default userPreferenceReducer;
